import type {Module} from "vuex";
import type {ModalInstance} from "@/api/modal";
import type {RootState} from "@/store/types";

export interface ModalsSplicePayload {
    index: number
    count: number
}

export interface ModalsState {
    items: ModalInstance[]
}

const modals: Module<ModalsState, RootState> = {
    namespaced: true,
    state: {
        items: []
    },
    mutations: {
        push(state, item: ModalInstance) {

            state.items.push(item);
        },
        splice(state, data: ModalsSplicePayload) {

            state.items.splice(data.index, data.count);
        },
        reject(state, index: number) {

            state.items[index].reject();
        }
    },
    actions: {
        push(context, item: ModalInstance) {

            context.commit('push', item);
        },
        splice(context, data: ModalsSplicePayload) {

            context.commit('splice', data);
        },
        reject(context, index: number) {

            context.commit('reject', index);
        }
    },
    getters: {
        items(state): ModalInstance[] {

            return state.items.slice(0);
        }
    }
}

export default modals
